// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"31e9c4e9","319":"3b313776","395":"96323ac2","580":"1db102ee"}[chunkId] + ".chunk.js";
};